import * as React from 'react';

import { getTermValue } from '../../../../../JsonQuery';
import { useContext } from '../../../utils/useContext';
import { OfferType } from '../../../components/advancedFilters/OfferType';

export const OfferTypeContainer: React.FC = () => {
  const { jsonQuery, specialPromo, onChange } = useContext();
  const fromDeveloper = getTermValue('from_developer')(jsonQuery);
  const promo = getTermValue('promo')(jsonQuery);
  const isSpecialPromoActive =
    jsonQuery.geo && specialPromo
      ? jsonQuery.geo.value.some(value => value.type === 'builder' && value.id === specialPromo.developerId)
      : null;

  const handleFromDeveloperChange = React.useCallback(
    (fromDeveloper: boolean | null) => {
      onChange({ action: 'setFromDeveloper', arguments: [fromDeveloper] });
    },
    [onChange],
  );

  const handlePromoChange = React.useCallback(
    (promo: boolean | null) => {
      onChange({ action: 'setPromo', arguments: [promo] });
    },
    [onChange],
  );

  const handleSpecialPromoChange = React.useCallback(
    (isSpecialPromoActive: boolean | null) => {
      if (!specialPromo) {
        return;
      }

      if (isSpecialPromoActive) {
        onChange({ action: 'selectGeo', arguments: [{ type: 'builder', id: specialPromo.developerId }] });
      } else {
        onChange({ action: 'removeGeo', arguments: [{ type: 'builder', id: specialPromo.developerId }] });
      }
    },
    [onChange, specialPromo],
  );

  return (
    <OfferType
      fromDeveloper={fromDeveloper}
      promo={promo}
      specialPromoLabel={specialPromo ? specialPromo.filterLabel : null}
      specialPromoActive={isSpecialPromoActive}
      onFromDeveloperChange={handleFromDeveloperChange}
      onPromoChange={handlePromoChange}
      onSpecialPromoChange={handleSpecialPromoChange}
    />
  );
};
